/* eslint-disable no-case-declarations */
import { toast } from 'react-toastify';
import { ACCESS_CARD, UPDATE_ACCESS_CARD } from "../action/constant";

const initialState ={
  loading:false,
  err:{},
  cards:{},
}

export default function accessCardsReducer(state = initialState, action){
  switch (action.type) {
    case ACCESS_CARD.PENDING:
      return {
        ...state,
        loading:true,
        err:{},
      }
    case ACCESS_CARD.SUCCESS:
      return {
        ...state,
        loading:false,
        err:{},
        cards:action.data,
      }
    case ACCESS_CARD.ERROR:
      return {
        ...state,
        loading:false,
        cards:action.err,
      }
    case UPDATE_ACCESS_CARD.PENDING:
      return {
        ...state,
        loading:true,
      }
    case UPDATE_ACCESS_CARD.SUCCESS:
      const filterData = [];
      state.cards.cards.every(v =>
        v._id !==  action.data.data._id ? filterData.push(v) : filterData.push(action.data.data)
      );
      return {
        ...state,
        cards: {...state.cards,cards:filterData},
        err: {},
        loading:false,
      };
    case UPDATE_ACCESS_CARD.ERROR:
      toast.dismiss();
      toast.error('Error while updating');
      return {
        ...state,
        loading:false,
        err:action.err,
      }
    default:
      return state;
  }
}
